module.exports = __webpack_public_path__ + "Roboto-Thin.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/fonts/roboto/Roboto-Thin.ttf
// module id = 100
// module chunks = 0